import { render, staticRenderFns } from "./NotamJsonModal.vue?vue&type=template&id=ef7844d4&scoped=true&"
import script from "./NotamJsonModal.vue?vue&type=script&lang=js&"
export * from "./NotamJsonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7844d4",
  null
  
)

export default component.exports